import React from "react";
import { Stack, Typography, Button } from "@mui/material";
import logoHeader from "../../../assets/fluxmed-logo-horizontal.png";
import { ContentBoxTitle } from "../../../components/common";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { endpoints } from "../../../configs/Settings";

interface FluxPayConfirmationProps {
  handleNext?: () => void;
}

export function FluxPayConfirmation({ handleNext }: FluxPayConfirmationProps) {
  // Função para abrir o portal em uma nova aba
  const handleOpenPortal = () => {
    window.open(endpoints.XDSB_domain, '_blank');
  };

  return (
    <Stack alignItems="center" spacing={10}>
      <Stack alignItems="center" spacing={2}>
        <img src={logoHeader} alt="Logo fluxmed" width={185} height="auto" />
        <ContentBoxTitle>Contrato FluxPay Concluído</ContentBoxTitle>
      </Stack>
      
      <Stack spacing={6} justifyContent="center" alignItems="center" sx={{ maxWidth: '600px' }}>
        <CheckCircleIcon sx={{ 
          color: 'success.main',
          fontSize: 80,
          mb: 2
        }} />
        
        <Typography variant="h6" align="center" fontWeight="500">
          Parabéns! Sua integração com o FluxPay foi concluída com sucesso.
        </Typography>
        
        <Typography variant="body1" align="center">
          Agora você pode oferecer aos seus pacientes a opção de pagamento via Mercado Pago
          diretamente pelo sistema Fluxmed. Não é necessário realizar nenhum pagamento adicional
          neste momento, pois o FluxPay funciona com base em taxa por uso.
        </Typography>
        
        <Typography variant="body1" align="center">
          Você pode continuar utilizando o sistema normalmente ou acessar o portal Fluxmed clicando no botão abaixo.
        </Typography>
        
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleOpenPortal}
          sx={{
            padding: '16px 32px',
            borderRadius: '8px',
            fontSize: '1rem',
            textTransform: 'none',
            minWidth: '220px',
            mt: 2
          }}
        >
          Abrir Portal Fluxmed
        </Button>
      </Stack>
    </Stack>
  );
} 